import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SchedulerPeriodPickerComponent } from './scheduler-period-picker.component';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
// eslint-disable-next-line max-len
import { PeriodPickerCalendarModule } from '@shared/components/scheduler-period-picker/period-picker-calendar/period-picker-calendar.module';
import { AppSelectModule } from '@ui-kit/app-select/app-select.module';
import { CommonPipesModule } from '@ui-kit/pipes/common-pipes.module';

@NgModule({
  declarations: [SchedulerPeriodPickerComponent],
  exports: [SchedulerPeriodPickerComponent],
  imports: [CommonModule, AppSelectModule, TranslateUiModule, CommonPipesModule, PeriodPickerCalendarModule]
})
export class SchedulerPeriodPickerModule {}
